import { render, staticRenderFns } from "./CourseFaqEditForm.vue?vue&type=template&id=357bef56&scoped=true&"
import script from "./CourseFaqEditForm.vue?vue&type=script&lang=js&"
export * from "./CourseFaqEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "357bef56",
  null
  
)

export default component.exports